import React from 'react'
import Styled from 'styled-components'

import Icon from 'components/Icon'

const Container = Styled.div`
  position: relative;
  width: 30rem;
  max-width: 100%;
`

const Line = Styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 0.25rem;
  border-radius: 0.125rem;
  background-color: ${props => props.theme.colors.primary.shade400};
`

const Circle = Styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 4rem;
  height: 4rem;
  border-radius: 4rem;
  background-color: ${props => props.theme.colors.primary.shade400};
`

const IconExtended = Styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  color: ${props => props.theme.colors.white};
`

export default () => (
  <Container>
    <Line />
    <Circle>
      <IconExtended liga="add" />
    </Circle>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/AddMarker/index.js